import G, { STORAGE_KEYS as o } from "../managers/storage-manager.js";
export function isDisabled() {
  return !!new G.ne(null, !0).lr(o.ae);
}
